"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Text = exports.MarketPrice = exports.InterestAmount = exports.Amount = exports.Action = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _reactRouterDom = require("react-router-dom");
var _get = _interopRequireDefault(require("lodash/get"));
var _APIcon = _interopRequireDefault(require("../common/APIcon"));
var _ProductIconContainer = _interopRequireDefault(require("../common/ProductIcon/ProductIconContainer"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _numberFormatter = require("../../helpers/numberFormatter");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('activity', 'interest-balances');
var Action = exports.Action = function Action(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('activity'),
    t = _useTranslation.t;
  var themeModifier = props.themeModifier,
    _onClick = props.onClick,
    row = props.row;
  var iconFileName = row.iconFileName,
    ProductId = row.ProductId;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('action')
  }, /*#__PURE__*/_react["default"].createElement(_ProductIconContainer["default"], {
    customClass: baseClasses('product-icon', themeModifier),
    iconFileName: iconFileName,
    size: 36
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('action-column')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('action-text', 'primary')
  }, (0, _get["default"])(row, 'ProductSymbol', '') + ' ' + row.ProductFullName), /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('action-text', 'secondary')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: "/activity",
    style: {
      display: 'flex',
      alignItems: 'center'
    },
    onClick: function onClick() {
      return _onClick(ProductId);
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      marginBottom: '-1rem',
      display: 'flex',
      alignItems: 'center'
    }
  }, t('Details'), " ", '   ', /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
    name: "arrowNext"
  })))))));
};
var Text = exports.Text = function Text(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('amount')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('amount-quantity')
  }, props.text));
};
var MarketPrice = exports.MarketPrice = function MarketPrice(_ref) {
  var NotionalValue = _ref.NotionalValue,
    NotionalProductSymbol = _ref.NotionalProductSymbol;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('amount'),
    style: {
      paddingLeft: '2.6rem'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('amount-quantity')
  }, "".concat((0, _numberFormatter.formatNumberToLocale)(NotionalValue, NotionalProductSymbol), " ").concat(NotionalProductSymbol || '')));
};
var Amount = exports.Amount = function Amount(props) {
  var _props$value = props.value,
    ProductSymbol = _props$value.ProductSymbol,
    rawAmount = _props$value.rawAmount;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('amount')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('amount-quantity')
  }, "".concat((0, _numberFormatter.formatNumberToLocale)(rawAmount, ProductSymbol), " ").concat(ProductSymbol || '')));
};
var InterestAmount = exports.InterestAmount = function InterestAmount(_ref2) {
  var ProductSymbol = _ref2.ProductSymbol,
    Amount = _ref2.Amount;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('amount')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('amount-quantity')
  }, "".concat((0, _numberFormatter.formatNumberToLocale)(Amount, ProductSymbol), " ").concat(ProductSymbol || '')));
};